/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ZeroExSwap, ZeroExSwapInterface } from "../ZeroExSwap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_exchangeProxy",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "TargetNotExchangeProxy",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sellToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "boughtAmount",
        type: "uint256",
      },
    ],
    name: "BoughtTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "EXCHANGE_PROXY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sellToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_swapCallData",
        type: "bytes",
      },
    ],
    name: "fillQuote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ZeroExSwapConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ZeroExSwapConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ZeroExSwap__factory extends ContractFactory {
  constructor(...args: ZeroExSwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ZeroExSwap";
  }

  deploy(
    _exchangeProxy: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ZeroExSwap> {
    return super.deploy(_exchangeProxy, overrides || {}) as Promise<ZeroExSwap>;
  }
  getDeployTransaction(
    _exchangeProxy: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_exchangeProxy, overrides || {});
  }
  attach(address: string): ZeroExSwap {
    return super.attach(address) as ZeroExSwap;
  }
  connect(signer: Signer): ZeroExSwap__factory {
    return super.connect(signer) as ZeroExSwap__factory;
  }
  static readonly contractName: "ZeroExSwap";
  public readonly contractName: "ZeroExSwap";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ZeroExSwapInterface {
    return new utils.Interface(_abi) as ZeroExSwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ZeroExSwap {
    return new Contract(address, _abi, signerOrProvider) as ZeroExSwap;
  }
}
